import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";


@Injectable({
    providedIn: 'root'
})

export class O2PortalASUReferenceListService
 {
    constructor(protected http: HttpClient) {
    }

    baseurl = environment.apiBaseUrl;

    getO2PortalASUReferenceList() {
        return this.http.get<any[]>(this.baseurl + 'O2PortalASUReferenceList');
    }
}